module.exports = __webpack_public_path__ + "static/media/Poppins-Semibold-latinext.a6ff41d1.woff2";